// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ih-0";
export var actionModalContentContainer = "_ih-1";
export var createTagButton = "_ih-2";
export var footerContainer = "_ih-7";
export var fullWidthDivider = "_ih-3";
export var hasCreateTagButton = "_ih-4";
export var noCreateTagButton = "_ih-5";
export var tagsContainer = "_ih-6";
export var tagsModalContentContainer = "_ih-8";